// The Studio is an unreleased draft. It only exists locally and on the Firebase
// preview channel "studio" (jewlai2--studio-*.web.app), never on jewlai.com.
const host = typeof window !== "undefined" ? window.location.hostname : ""
export const STUDIO_ENABLED =
  host === "localhost" || host === "127.0.0.1" || host.includes("--studio")
